module.exports = __webpack_public_path__ + "static/media/Graphik-Light.89ccded6.woff";